/* eslint-disable jsx-a11y/anchor-is-valid */
import LogSymbol from "@assets/img/logo/logo-symbol.svg";
import LogoText from "@assets/img/logo/logo-text.svg";
import { FaFingerprint, FaPersonCircleCheck } from "react-icons/fa6";

import React, { useEffect, useRef, useState } from "react";
import { FaHandsHelping, FaHome, FaServer } from "react-icons/fa";

import { useSidebarCollapse } from "@hooks/contexts/SidebarCollapseContext";

import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { NavLink, useLocation } from "react-router-dom";

export default function NavbarLeft() {
  // --- Miscs --- //
  const location = useLocation();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();
  const isActive = (paths: string[]) =>
    paths.some((path) => location.pathname.startsWith(path));
  const { isCollapsed, toggleSidebar, handleMouseEnter, handleMouseLeave } =
    useSidebarCollapse();

  // let submenu active only when selected
  const [activeSubmenuHistoric, setActiveSubmenuHistoric] = useState(false);
  const [activeSubmenuEvent, setActiveSubmenuEvent] = useState(false);

  function handleClickHistoric(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    setActiveSubmenuHistoric((prevState) => !prevState);
    setActiveSubmenuEvent(false);
  }

  function handleClickEvent(e: React.MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    setActiveSubmenuEvent((prevState) => !prevState);
    setActiveSubmenuHistoric(false);
  }

  function inMaintenance() {
    pushToastify({
      message: `Página em construção, por favor, tente novamente mais tarde.`,
      type: "info",
      theme: "dark",
    });
  }

  // minimize dropdown when the route change
  const historicRef = useRef<HTMLDivElement>(null);
  const eventRef = useRef<HTMLDivElement>(null);

  // routes that dont close the dropdown of historic
  const submenuPathsHistoric = ["#", "#", "#", "#", "#"];
  // routes that dont close the dropdown of event
  const submenuPathsEvent = ["/event/own", "#", "#", "#"];

  useEffect(() => {
    if (
      !submenuPathsHistoric.some((path) => location.pathname.startsWith(path))
    ) {
      if (historicRef.current) {
        historicRef.current.classList.remove("show");
        historicRef.current.classList.add("collapsing");
        historicRef.current.classList.remove("collapsing");
      }
      setActiveSubmenuHistoric(false);
    }

    if (!submenuPathsEvent.some((path) => location.pathname.startsWith(path))) {
      if (eventRef.current) {
        eventRef.current.classList.remove("show");
        eventRef.current.classList.add("collapsing");
        eventRef.current.classList.remove("collapsing");
      }
      setActiveSubmenuHistoric(false);
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-background-color="white"
      >
        <div className="sidebar-logo">
          <div className="logo-header" data-background-color="white">
            <NavLink to="/" className=" logo">
              <img
                src={LogSymbol}
                alt="navbar brand"
                className="navbar-brand"
                height="35"
              />
              <img
                src={LogoText}
                alt="navbar-text"
                className="navbar-brand ms-2"
                height="20"
              />
            </NavLink>
            <div className="nav-toggle">
              <button
                className="btn btn-toggle toggle-sidebar"
                onClick={toggleSidebar}
              >
                <i className="gg-menu-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="sidebar-wrapper scrollbar scrollbar-inner">
          <div className="sidebar-content">
            <ul className="nav nav-secondary">
              {/* DASHBOARD AREA */}
              <li className={`nav-item`}>
                <NavLink to="/home" className="link">
                  <div className="icon">
                    <FaHome />
                  </div>
                  <p>Dashboard</p>
                </NavLink>
              </li>

              {/* USER AREA */}
              <li className="nav-section">
                <span className="sidebar-mini-icon">
                  <i className="fa fa-ellipsis-h"></i>
                </span>
                <h4 className="text-section">Controle</h4>
              </li>

              <li className={`nav-item ${isActive(["/infrastructure/list"]) ? "active" : ""}`}>
                <NavLink to="/infrastructure/list" className="link">
                  <div className="icon">
                    <FaServer />
                  </div>
                  <p>Infraestruturas</p>
                </NavLink>
              </li>

              {/* Test */}
              <li className={`nav-item ${isActive(["/platformHealth/list"]) ? "active" : ""}`}>
                <NavLink to="/platformHealth/list" className="link">
                  <div className="icon">
                    <FaPersonCircleCheck />
                  </div>
                  <p>Plataformas</p>
                </NavLink>
              </li>

              {/* JUST DIVISOR */}
              <li className="nav-section">
                <span className="sidebar-mini-icon">
                  <i className="fa fa-ellipsis-h"></i>
                </span>
              </li>

              {/* JUST DIVISOR */}
              <li className="nav-section">
                <span className="sidebar-mini-icon">
                  <i className="fa fa-ellipsis-h"></i>
                </span>
              </li>

              {/* CUSTOMER SETTINGS */}
              <li className="nav-section">
                <span className="sidebar-mini-icon">
                  <i className="fa fa-ellipsis-h"></i>
                </span>
                <h4 className="text-section">Configurações</h4>
              </li>

              <li className={`nav-item ${isActive(["#"]) ? "active" : ""}`}>
                <NavLink to="/account" className="link">
                  <div className="icon">
                    <FaFingerprint />
                  </div>
                  <p>Minha Conta</p>
                </NavLink>
              </li>

              {/* HELP */}
              <li className="nav-section">
                <span className="sidebar-mini-icon">
                  <i className="fa fa-ellipsis-h"></i>
                </span>
                <h4 className="text-section">AJUDA</h4>
              </li>

              <li className={`nav-item ${isActive(["#"]) ? "active" : ""}`}>
                <a data-bs-toggle="collapse" href="#" onClick={inMaintenance}>
                  <div className="icon">
                    <FaHandsHelping />
                  </div>
                  <p>Informações</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
